<template>
    <div class="row justify-content-center" v-if="userConfig">
        <div class="col-12 col-md-10 col-lg-6 ">
            <div class="card" v-if="isValidPlan">
                <p v-if="planObj.planImages.front == ''">{{'Loading...' | translate}}</p>
                <img class="card-img-top" :src="planObj.planImages.front">
                <div class="card-body">
                    <h3 class="card-title">
                        {{planObj.planName}}
                    </h3>
                    <div class="card-text">
                        <p v-html="urlify(planObj.planDescription)"></p>
                    </div>
                    <div class="blockquote-footer text-right">
                        {{'Ticket Provider:' | translate}} {{planObj.fanPageID}}
                    </div>
                </div>
                <div class="input-group input-group-lg" >
                    <input class="form-control" type="text"  @blur="$v.ui.phone.$touch()" v-model="ui.phone" :placeholder="$t('Input Phone Number')" :class="{'border':$v.ui.phone.$error,'border-danger':$v.ui.phone.$error}">
                    <div class="input-group-append">
                        <button :disabled="$v.$invalid" class="btn" :class="{'btn-primary':PSID, 'btn-secondary':!PSID}" @click="singleIssue({'phone':ui.phone});clearInputFields()">{{ui.issueButtonText | translate}}</button>
                    </div>
                </div>
                <small v-if="$v.ui.phone.$error" class="text-danger">{{'Please Input valid phone number' | translate}}</small>
                <span v-if="userConfig" class="card-text">
                    <i class="fas fa-circle" 
                        :style="{'color':userConfig.sendSMS?(userConfig.KOTSMS.userName && userConfig.KOTSMS.passWord?'green':'yellow'):'red'}">
                    </i>
                    {{userConfig.sendSMS?(userConfig.KOTSMS.userName && userConfig.KOTSMS.passWord? $t('SMS turned On')+' '+$t('Balance: {value}',{'value':ui.KOTSMSBalance}):$t('KOTSMS not set')):$t('SMS turned Off')}}
                </span>
                <span v-if="planObj.planIssueMethod == 'stock' && planObj.stockTickets" class="card-text">
                    <i class="fas fa-circle"
                        :style="{'color':Object.keys(planObj.stockTickets).length!=0?'green':'red'}">
                    </i>
                    {{$t('This plan is issued from stock.')}}
                    {{Object.keys(planObj.stockTickets).length!=0
                    ? $t('There are {value} tickets in stock',{'value':Object.keys(planObj.stockTickets).length})
                    : $t('There are no tickets in stock')}}
                </span>
                <span v-if="planObj.planIssueMethod == 'stock' && !planObj.stockTickets" class="card-text">
                    <i class="fas fa-circle"
                        :style="{'color':'red'}">
                    </i>
                    {{$t('This plan is issued from stock but not stock tickets')}}
                </span>
                <small v-if="!$v.ui.phone.$invalid" class="text-success">{{ui.statusMsg}}</small>

                <div class="card-footer">
                    <div class="form-group row">
                        <button :disabled="$v.$invalid" class="col-6 card-text btn" :class="{'btn-secondary':!$v.$invalid,'btn-light':$v.invalid}"
                        @click="checkIfFullyRegistered({'phone':ui.phone})">{{'Check if Registered' | translate}}</button>
                        <button :disabled="$v.$invalid" class="col-6  card-text btn" :class="{'btn-secondary':!$v.$invalid,'btn-light':$v.invalid}"
                        @click="getRegisterLink({'phone':ui.phone})">{{'Get Register Link' | translate}}</button>
                    </div>
                    <div class="form-group row">
                        <button :disabled="$v.$invalid" class="col-12  card-text btn" :class="{'btn-secondary':!$v.$invalid,'btn-light':$v.invalid}" 
                        @click="generateRegisterQRcode({'phone':ui.phone})">{{'Get QRcode' | translate}}</button>
                    </div>
                    
                    <div class="row">
                        <div class="mx-auto"><canvas id="canvas" height="10"></canvas></div>
                    </div>
                    
                    <div class="card-text text-right">
                        <small>{{'Powered by Sharelike.' | translate}}</small>
                    </div>
                    
                </div>
                
                
            </div>
            <div v-if="!isValidPlan">
                <p>{{'Invalid URL' | translate}}</p>
            </div> 

            <app-modal 
            :options="{
                'isAlert':isAlert,
                'modalTitle':modalTitle,
                'modalText':modalText
            }" @modalEvent="onModalEvent">
            </app-modal>
        </div>
        <div class="col-12 col-md-10 col-lg-6">
            <div v-if="true" class="form-group">
                <div class="custom-file">
                        <input class="custom-file-input btn" type="file" @change="processCsvFile($event.target.files[0],csvObj)" accept=".csv"> 
                        <label class="custom-file-label"  :style='"--file-content:\""+$t("Browse")+"\""'>{{'Upload Batch CSV File or Paste Phone List' | translate}}</label>
                </div>
                <textarea class="form-control" rows="10"  v-model="phoneList"></textarea>
                <span>
                    {{$t('Already imported {number} phones.',{'number':Object.values(csvObj.data).filter(a=>a.phone).length})}}
                </span>
                <div class="input-group" >
                        <button class="btn btn-info"  @click="batchIssue(csvObj.data)">{{'Batch Issue Ticket' | translate}}</button>
                        <label class="form-control">{{ui.batchStatusMsg}}</label>
                </div>
                <span v-if="userConfig" class="card-text">
                    <i class="fas fa-circle" 
                        :style="{'color':userConfig.sendSMS?(userConfig.KOTSMS.userName && userConfig.KOTSMS.passWord?'green':'yellow'):'red'}">
                    </i>
                    {{userConfig.sendSMS?(userConfig.KOTSMS.userName && userConfig.KOTSMS.passWord? 
                        $t('SMS turned On')+' '+$t('Balance: {value}',{'value':ui.KOTSMSBalance})+' '+$t('Going to use {amount} KOTSMS points',{'amount':Object.values(csvObj.data).length*userConfig.smsAmount}):
                        $t('KOTSMS not set')):$t('SMS turned Off')}}
                </span>
                <br/>
                <!-- TODO because of stockTickets, planObj is very fat, should refine-->
                <span v-if="planObj.planIssueMethod == 'stock' && planObj.stockTickets" class="card-text">
                    <i class="fas fa-circle"
                        :style="{'color':Object.keys(planObj.stockTickets).length!=0?'green':'red'}">
                    </i>
                    {{$t('This plan is issued from stock.')}}
                    {{Object.keys(planObj.stockTickets).length!=0
                    ? $t('There are {value} tickets in stock',{'value':Object.keys(planObj.stockTickets).length})
                    : $t('There are no tickets in stock')}}
                </span>
                <span v-if="planObj.planIssueMethod == 'stock' && !planObj.stockTickets" class="card-text">
                    <i class="fas fa-circle"
                        :style="{'color':'red'}">
                    </i>
                    {{$t('This plan is issued from stock but no stock tickets')}}
                </span>
            </div>
        </div>
    </div>
</template>
<script>
import {required, numeric, minLength, maxLength} from 'vuelidate/lib/validators';
import Modal from './Modal.vue';
import firebase from 'firebase';
import QRcode from 'qrcode';
import axios from 'axios';
import Papa from 'papaparse';

// import PhoneNumberDialog from './PhoneNumberDialog.vue';

export default {
    components:{
        appModal:Modal
    },
    data(){
        return {
            ui:{
                issueButtonText:'Issue Ticket',
                statusMsg:'',
                phone:'',
                batchStatusMsg:'',
                batchCounter:0,
                KOTSMSBalance:0
            },
            
            currentUser:null,
            userConfig:null,
            isAlert:false,
            modalTitle:'',
            modalText:'',
            planObj:{
                'planID':'',
                'planName':'',
                'planType':'',
                'planDescription':'',
                'planImages':{},
                'fanPageID':''
            },
            isValidPlan:null,
            PSID:'',
            csvObj:{
                data:''
            },
            phoneList:[],
        }
    },
    validations:{
        ui:{
            phone:{
                required,
                numeric,
                minLength:minLength(10),
                maxLength:maxLength(10)
            }
        }
    },
    watch:{
        currentUser(){
            this.getUserConfig();
            this.validatePlan();
        },
        userConfig(){
            this.getKOTSMSBalance();
        },
        $v:{
            handler(value){
                if(!value.ui.phone.$invalid)
                    this.getCustomerPSID({'phone':this.ui.phone});
                else
                    this.PSID='';
           },
           deep:true
        },
        PSID(value){
            if(value)
                this.ui.issueButtonText="Push Ticket"
            else
                this.ui.issueButtonText="Issue Ticket"
        },
        csvObj:{ // TODO move to mixins 
            handler(){
                this.phoneList = Object.values(this.csvObj.data).map(a=>a.phone).join('\n');
            },
            deep:true
        },
        phoneList(){ // TODO move to mixins 
            this.csvObj.data = this.phoneList.split('\n').map(a=>{return {'phone':a}});
        }
    },
    methods:{
        messengerRefLink(obj){
            var str = 'https://m.me/' + this.planObj.fanPageID + '/?ref='
                 + process.env.VUE_APP_FIREBASE_DATABASEURL + '/users/'+this.currentUser.uid
                 + '/customers/'+obj.customerID +'--'+process.env.VUE_APP_STAGE;
            // console.log('For ',obj.phone,', produced messengerRefLink: ',str);
            return str;
        },
        urlify(str) {//move to mixin
            var urlRegex = /(https?:\/\/[^\s]+)/g
                return str.replace(urlRegex, function(url) {
                    return '<a href="' + url + '" target="_blank">' + url + '</a>'
                })
            
        },
        validatePlan(){
            // console.log('Validating Plan...');
            var databaseRef = firebase.database().ref('users/' + this.currentUser.uid + '/plans');
            var self = this;
            databaseRef.once('value')
                .then(function(snapshot) {
                    
                    if(snapshot.hasChild(self.$route.params.key)){
                        // console.log('Valid URL, Plan exists');
                        self.isValidPlan = true;
                        self.planObj = snapshot.val()[self.$route.params.key];
                        
                    }else{
                        // console.log('Invalid URL, Plan not exists');
                        self.isValidPlan = false;
                        
                    }
                    
                },function(error){
                    // console.log('Validate URL error: ' + error);

                });
        },
        getUserConfig(){//Warning massive duplicate code
            // console.log('Fetching User Config');
            var databaseRef = firebase.database().ref('users/' + this.currentUser.uid + '/config');
            var self = this;
            databaseRef.once('value')
                .then(function(snapshot) {
                    
                    if(snapshot!=null){
                        // console.log('Loaded User config');
                        self.userConfig = snapshot.val();
                        
                    }else{
                        // console.log('User config not exists');
                        
                    }
                    
                },function(error){
                    // console.log('Loading User config  error: ' + error);
                });

        },
        getRegisterLink(obj){//from ui.phone
            var self =this;
            // var obj = {};
            // obj['phone'] = phone;
            this.isRegistered(obj).then(result=>{
                if(result) {
                    self.modalAlert(
                        self.$t('Get Register Link'),
                        self.$t('Customer HAS registered.\nRegister link:\n ')+ self.messengerRefLink(obj)
                    );
                }
                else {
                    return self.registerCustomer(obj).then((obj)=>self.callSendSMS(obj));
                }
            });
        },
        getKOTSMSBalance(){
            axios.get(`https://api.kotsms.com.tw/memberpoint.php?username=${this.userConfig.KOTSMS.userName}&password=${this.userConfig.KOTSMS.passWord}`)
                .then(res=>{
                    this.ui.KOTSMSBalance = res.data;
                });

        },
        callSendSMS(obj){
            // console.log('Calling Backend to send SMS',this.messengerRefLink(obj));
            // console.log(obj);
            var self = this;

            if(!self.userConfig.sendSMS){
                console.log('SMS Turned Off');
                // self.ui.statusMsg = self.$t('Register SMS Turned Off');
                return;
            }

            if(self.userConfig.KOTSMS.userName&&self.userConfig.KOTSMS.passWord){
                var smsObj = {};
                smsObj['phone'] = obj.phone;
                smsObj['userName'] = this.userConfig.KOTSMS.userName;
                smsObj['passWord'] = this.userConfig.KOTSMS.passWord;
                smsObj['smsBody'] = this.userConfig.smsBody;
                smsObj['messengerRefLink'] = this.messengerRefLink(obj);
                smsObj['planObj'] = this.planObj;
                // smsObj['imageURL'] = this.planObj.planImages.front;


                return axios.post(process.env.VUE_APP_BACKEND_URL + '/send_sms.php',smsObj)
                    .then(res => {
                        // console.log('Register SMS ',smsObj,' has sent to: ', obj.phone)
                        // self.ui.statusMsg = self.$t('Register SMS has sent to: ') + obj.phone;
                    })
                    .catch(error => console.log(error));
            }else{
                self.ui.statusMsg = self.$t('KOTSMS account has not set');
                console.log('KOTSMS account not set');
            }


        },
        checkIfFullyRegistered(obj){//from ui.phone
            var self = this;
            var checkObj ={
                'isRegistered':false,
                'PSID':null
            };
            // var obj = {};
            // obj['phone'] = phone;
            this.isRegistered(obj).then(result=>{
                if(result)
                    checkObj.isRegistered=true;
                else 
                    checkObj.isRegistered=false;
                
            })
            .then(()=>{
                return self.getCustomerPSID(obj).then((result)=>{
                    if(result!=null) 
                        checkObj.PSID = result;  
                    });
            })
            .then(()=>{
                // console.log(checkObj);
                if(!checkObj.isRegistered)
                    self.modalAlert(self.$t('Check if customer registered'),self.$t('Customer has NOT registered.'));
                else if(!checkObj.PSID)
                    self.modalAlert(self.$t('Check if customer registered'),self.$t('Customer HAS registered, but HAS NOT bound facebook messenger.'));
                else
                    self.modalAlert(self.$t('Check if customer registered'),self.$t('Customer HAS fully registered.'));

            });
        },
        generateRegisterQRcode(obj){//from ui.phone
            var self =this;
            // var obj = {};
            // obj['phone'] = phone;
            this.isRegistered(obj).then(result=>{
                if(result) {
                    QRcode.toCanvas(canvas, self.messengerRefLink(obj), function (error) {
                        if (error) console.log('QRcode generating error.')
                    });
                }else{ 
                    self.modalAlert(self.$t('Generating QRcode...'),self.$t('Customer has NOT registered.'));
                }
            });
            
        },
        processCsvFile(file,obj){
            Papa.parse(file, {
                worker: false,
                header:true,
                step:null,
                complete: function(results) {
                    obj.data = results.data;
                    // console.log("Row:", results.data);
                }
            });

        },
        singleIssue(obj){
            this.issueFlow(obj)
                .then(()=>{
                    console.log(`${obj.phone} issued`,obj);
                    this.modalAlert(this.$t('Issue Ticket'),this.$t('Ticket has issued successfully'));
                });
        },
        batchIssue(arr){
            var self = this;
            //batch initial
            this.ui.batchCounter = 0;
            this.ui.batchStatusMsg = this.$t('Issuing... Do not close window.');
            var validArr = arr.filter(a=>/^[+]*[0-9]{4,15}$/.test(a.phone));
            validArr.forEach((obj,index)=>{
                obj.index = index;
                obj.batchSize = validArr.length;
                // console.log('in '+ obj.phone + ' turn:',obj);
                this.issueFlow(obj)
                    .then(()=>{
                        // console.log(`${obj.index+1} ${obj.phone} issued`,obj);
                        self.ui.batchCounter++
                        self.ui.batchStatusMsg = self.$t('Issuing... {progress} items issued',{'progress':`${self.ui.batchCounter}/${obj.batchSize}`});
                        if(self.ui.batchCounter == obj.batchSize)
                            this.ui.batchStatusMsg = self.$t('Batch issue {size} complete',{'size':obj.batchSize});
                    });
                
            })
        },
        issueFlow(obj){
            // console.log('Starting Issue Flow...');
            // console.log(obj);
            var self = this;
            return self.isRegistered(obj)
                .then(function(isRegistered){
                    if(isRegistered){
                        return self.issueTicket(obj);
                    }else{
                        return self.registerCustomer(obj)
                                .then(()=>self.callSendSMS(obj))
                                .then(function(){
                                    return self.issueTicket(obj);
                                });      
                    }
                })
                .then(()=>{ 
                    obj='';
                })
                .catch(err=>console.log('issue flow error',err));

        },
        clearInputFields(){
            // console.log("Clear input fields");
            this.$v.ui.phone.$reset();
            this.ui.phone='';
            this.ui.statusMsg ='';
        },
        registerCustomer(obj){
            // console.log('Registering customer');
            // console.log(obj);
            var databaseRef = firebase.database().ref('users/' +this.currentUser.uid+ '/customers/');
            var self = this;
            var customerObj ={};
            customerObj['phone'] = obj.phone;
            return databaseRef.push(customerObj, function(error) {
                    if (error) {
                        // console.log("Customer register failed...");
                    } else {
                        // console.log("Customer register success!");
                        
                    }
                })
                .then(snapshot=>{
                    obj['customerID'] = snapshot.key;
                    return obj;
                });
            
        },
        isRegistered(obj){
            // console.log('Checking if customer registered');
            // console.log(obj);
            var self = this;
            return new Promise((resolve, reject) => {
            
            var databaseRef = firebase.database().ref('users/' +this.currentUser.uid+ '/customers')
                .orderByChild('phone').equalTo(obj.phone);
            databaseRef.once('value')
                .then(function(snapshot) {
                    //console.log(snapshot.val());
                    if(snapshot.val()!= null){
                        // console.log('Customer has registered');
                        obj.customerID = Object.keys(snapshot.val())[0];
                        resolve(obj);
                    }else{
                        // console.log('Customer has not registered');
                        resolve(false);
                    }
                    
                },function(error){
                    // console.log('check isRegistered error: ' + error);
                    reject(error);
                });
            });    
        },
        issueTicket(obj){
            // console.log('Issuing Ticket to: ' + obj.phone + '(' + obj.customerID + ')',obj);
            return this.planObj.planIssueMethod!='stock'
                ? this.issueNewTicket(obj)
                : this.issueStockTicket(obj);

        },
        issueNewTicket(obj){
            var self = this;
            var ticketRef = firebase.database().ref('users/' +this.currentUser.uid+ '/tickets/').push();
             
            obj.ticketID = ticketRef.key;
            obj.ticketURL = 'https://' + process.env.VUE_APP_FIREBASE_AUTHDOMAIN + '/ticket/'+this.currentUser.uid+'|'+obj.ticketID;
            var ticketObj ={};
            ticketObj = JSON.parse(JSON.stringify(this.planObj));
            delete ticketObj.messageTemplates;
            ticketObj['owner'] = obj.customerID;
            ticketObj['ticketID'] = obj.ticketID;
            ticketObj['ticketURL'] = obj.ticketURL;
            ticketObj['status'] = 'issued';

            var updates ={};
            updates['users/' + this.currentUser.uid + '/customers/'+obj.customerID+'/tickets/' + obj.ticketID] = ticketObj;
            updates['users/' + this.currentUser.uid + '/tickets/' + obj.ticketID] = ticketObj;
            
            return firebase.database().ref().update(updates)
                .then(function(){
                    // self.ui.statusMsg = self.$t('Ticket has issued successfully');
                    // self.modalAlert(self.$t('Issue Ticket'),self.$t('Ticket has issued successfully'));
                    // console.log('Ticket url: ' + window.location.origin + '/ticket/' + self.currentUser.uid + '|' + obj.ticketID);
                    return obj;
                })
                .then(obj=>self.callPushTicket(obj));
        },
        issueStockTicket(obj){
            var self = this;
            var ticketObj={};
            var updates ={};
            // var ticketRef = firebase.database().ref('users/' +this.currentUser.uid+ '/tickets/').push();
            var stockRef =  firebase.database().ref('users/' +this.currentUser.uid+ '/plans/' +this.planObj.planID+ '/stockTickets')
            return stockRef.once('value')
                .then((snapshot)=>{
                    if(snapshot.hasChildren()){
                        obj.ticketID = Object.keys(snapshot.val())[0];
                        ticketObj = JSON.parse(JSON.stringify(snapshot.val()[obj.ticketID]));
                        obj.ticketURL = ticketObj.ticketURL
                        console.log('[issueStockTicket] got ticketObj:',ticketObj);
                    }else{
                        console.log('[issueStockTicket] stockRef has no children');
                        throw "stockRef has no children"
                    }
                })
                .then(()=>{
                    //modify ticket in tickets, under customer, delete plan stock
                    if(!obj.ticketID) throw "No stock tickets";

                    stockRef.child(obj.ticketID).remove();
                    ticketObj['owner'] = obj.customerID;
                    ticketObj['status'] = 'issued';
                    updates['users/' + this.currentUser.uid + '/customers/'+obj.customerID+'/tickets/' + obj.ticketID] = ticketObj;
                    updates['users/' + this.currentUser.uid + '/tickets/' + obj.ticketID] = ticketObj;
                    firebase.database().ref().update(updates)
                },function(error){
                    console.log('[issueStockTicket] ERROR',error);
                })
                .then(function(){
                    return obj;
                })
                .then(obj=>self.callPushTicket(obj))
                .catch(err=>{
                    console.log(err);
                });
            
            
            // obj.ticketID = ticketRef.key;
            // obj.ticketURL = 'https://' + process.env.VUE_APP_FIREBASE_AUTHDOMAIN + '/ticket/'+this.currentUser.uid+'|'+obj.ticketID;
            // var ticketObj ={};
            // ticketObj = JSON.parse(JSON.stringify(this.planObj));
            // delete ticketObj.messageTemplates;
            // ticketObj['ticketID'] = obj.ticketID;
            // ticketObj['ticketURL'] = obj.ticketURL;
            // ticketObj['owner'] = obj.customerID;
            // ticketObj['status'] = 'issued';

            // var updates ={};
            // updates['users/' + this.currentUser.uid + '/customers/'+obj.customerID+'/tickets/' + obj.ticketID] = ticketObj;
            // updates['users/' + this.currentUser.uid + '/tickets/' + obj.ticketID] = ticketObj;
            
            // return firebase.database().ref().update(updates)
            //     .then(function(){
            //         return obj;
            //     })
            //     .then(obj=>self.callPushTicket(obj));
        },
        getCustomerPSID(obj){//from ui.phone
            // console.log('Getting PSID of ' + obj.phone + '...');
            // console.log(obj);
            //get customer PSID from firebase
            var databaseRef = firebase.database().ref('users/' +this.currentUser.uid+ '/customers').orderByChild('phone').equalTo(obj.phone)
            var self = this;
            return databaseRef.once("value")
                .then((snapshot)=>{
                    if((snapshot.val()!=null)&&(Object.values(snapshot.val())[0].messengerPSID)){
                        console.log('got customer PSID: ',Object.values(snapshot.val())[0].messengerPSID[self.planObj.fanPageID]);
                        self.PSID = Object.values(snapshot.val())[0].messengerPSID[self.planObj.fanPageID];
                        return Object.values(snapshot.val())[0].messengerPSID[self.planObj.fanPageID];
                    }else{
                        // console.log('customer PSID == null');
                        self.PSID = '';
                        return false;
                    }
                        
                });

        },
        callPushTicket(obj){//TODO 若已知沒有拿到PSID 可以不用推送
            // console.log('Calling Backend to push ticket: ' + obj.ticketID);
            // console.log(obj);
            var pushObj = {};

            // pushObj['PSIDRef'] = process.env.VUE_APP_FIREBASE_DATABASEURL + '/users/'+this.currentUser.uid+'/customers/'+obj.customerID+'/PSID.json'+'--'+process.env.VUE_APP_STAGE;
            pushObj['PSIDRef'] = process.env.VUE_APP_FIREBASE_DATABASEURL + '/users/'+this.currentUser.uid+'/customers/'+obj.customerID+'/messengerPSID/'+this.planObj.fanPageID+'.json'+'--'+process.env.VUE_APP_STAGE;
            pushObj['fanPageID'] = this.planObj.fanPageID;
            pushObj['messageObj'] = JSON.parse(this.planObj.messageTemplates.messenger
                    .replace('%title%',this.planObj.planName)
                    .replace('%image_url%',this.planObj.planImages.front)
                    .replace('%subtitle%',this.planObj.planDescription.replace(/\n/g,'\\n')+'\\nID:'+obj.ticketID)
                    .replace('%url%',obj.ticketURL)
            );
            return axios.post(process.env.VUE_APP_BACKEND_URL + '/fb_push_ticket.php',pushObj)
            // .then(res => console.log('Called push ticket.'))
            .catch(error => console.log(error));

        },
        modalAlert(title,text){
            this.modalTitle = title;
            this.modalText = text;
            this.isAlert = true;
        },
        onModalEvent(event){
            this.isAlert = false;
            this.modalTitle = '';
            this.modalText = '';
        },
        getCurrentUser(){//Warning: massive duplicate code
                var self =this;
                firebase.auth().onAuthStateChanged(function(user) {
                    if (user) {
                        self.currentUser = user;
                    } else {
                        // console.log('No user has signed in.');
                    }
                })
        },
        
    },
    mounted(){//Warning: massive duplicate code
        this.getCurrentUser();
        
        

    }
    
}
</script>
<style scoped>
.custom-file-label::after {
    content:var(--file-content);
}
p {
    white-space:pre-wrap;
    word-wrap: break-word;
}
</style>
